import React from "react";
import ControlPointIcon from "@material-ui/icons/ControlPoint";

type Props = {
  onClick: () => void;
};

export default function CreateLinkCard({ onClick }: Props) {
  return (
    <button
      className="cw-flex cw-items-center cw-justify-center cw-cursor-pointer cw-bg-gray-50 hover:cw-bg-gray-100 cw-rounded-md cw-border-solid cw-border-2 cw-border-gray-100 cw-w-full cw-h-[228px]"
      onClick={onClick}
      cw-id="create-link-card"
    >
      <div className="cw-flex cw-items-center cw-gap-2 cw-text-dusk-standard cw-font-brand">
        <ControlPointIcon />
        <span className="cw-text-lg">Create a link</span>
      </div>
    </button>
  );
}
